import React from 'react';
import PropTypes from 'prop-types';

import { WHITE, PORCELAIN } from '@constant/colors';

const CardsStack = ({ width }) => {
  const height = Math.round(width * 0.66);

  return (
    <svg width={width} height={height} viewBox={`6 -1 ${width} ${height}`}>
      <defs>
        <rect id="cards-stack-a" x="16" width="91.778" height="51.625" rx="2" />
        <mask id="cards-stack-e" x="-1" y="-1" width="93.778" height="53.625">
          <path fill={WHITE} d="M15-1h93.778v53.625H15z" />
          <use xlinkHref="#cards-stack-a" />
        </mask>
        <rect
          id="cards-stack-b"
          x="12"
          y="4"
          width="100"
          height="56.25"
          rx="2"
        />
        <mask id="cards-stack-f" x="-1" y="-1" width="102" height="58.25">
          <path fill={WHITE} d="M11 3h102v58.25H11z" />
          <use xlinkHref="#cards-stack-b" />
        </mask>
        <rect
          id="cards-stack-d"
          x="7"
          y="9"
          width="110"
          height="61.875"
          rx="2"
        />
        <mask id="cards-stack-h" x="-1" y="-1" width="112" height="63.875">
          <path fill={WHITE} d="M6 8h112v63.875H6z" />
          <use xlinkHref="#cards-stack-d" />
        </mask>
      </defs>
      <g fill="none">
        <use fillRule="evenodd" />
        <use
          stroke={PORCELAIN}
          mask="url(#cards-stack-e)"
          strokeWidth="2"
          xlinkHref="#cards-stack-a"
        />
      </g>
      <g fill="none">
        <use fillRule="evenodd" xlinkHref="#cards-stack-b" />
        <use
          stroke={PORCELAIN}
          mask="url(#cards-stack-f)"
          strokeWidth="2"
          xlinkHref="#cards-stack-b"
        />
      </g>
      <mask id="card-stack-i" fill={WHITE}>
        <use xlinkHref="#cards-stack-d" />
      </mask>
      <g fill="none">
        <use
          fill="url(#cards-stack-g)"
          fillRule="evenodd"
          xlinkHref="#cards-stack-d"
        />
        <use
          stroke={PORCELAIN}
          mask="url(#cards-stack-h)"
          strokeWidth="2"
          xlinkHref="#cards-stack-d"
        />
      </g>
    </svg>
  );
};

CardsStack.propTypes = {
  width: PropTypes.number,
};

CardsStack.defaultProps = {
  width: 120,
};

export default CardsStack;
